import React from "react";
import { Button } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const CompanyEmployeeDeleteModal = (props) => {
	
	const handleClose = () => {
		props.onConfirm(false)
	};
	
	const handleYes = () => {
		props.onConfirm(true)
	};
	
	const handleNo = () => {
		props.onConfirm(false)
	};
	
	return (
		<Dialog
			open={props.employee? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				{`Delete Employee`}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					Are you sure you want to delete employee with email 
					{props.employee? props.employee.email : ""}?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleYes}>Yes</Button>
				<Button onClick={handleNo} autoFocus>No</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CompanyEmployeeDeleteModal;